var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "single-seo-txt__container" }, [
    _c("div", { staticClass: "single-seo-txt__left d-none d-xl-block" }, [
      _c("img", {
        attrs: { src: _vm.img, alt: _vm.headline, title: _vm.headline },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "single-seo-txt__right" }, [
      _c("img", {
        staticClass: "d-xl-none",
        attrs: { src: _vm.imgMobile, alt: _vm.headline, title: _vm.headline },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "single-seo-txt__headline" }, [
        _vm._v(_vm._s(_vm.headline)),
      ]),
      _vm._v(" "),
      _c("div", {
        staticClass: "single-seo-txt__txt",
        class: { "single-seo-txt__txt--open": _vm.isOpen },
        domProps: { innerHTML: _vm._s(_vm.text) },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "single-seo-txt__btn",
          on: {
            click: function ($event) {
              _vm.isOpen = !_vm.isOpen
            },
          },
        },
        [
          !_vm.isOpen
            ? _c(
                "svg",
                { attrs: { width: "8", height: "8", fill: "currentColor" } },
                [_c("use", { attrs: { "xlink:href": "#plus" } })]
              )
            : _c(
                "svg",
                { attrs: { width: "8", height: "8", fill: "currentColor" } },
                [_c("use", { attrs: { "xlink:href": "#minus" } })]
              ),
          _vm._v(
            "\n\n\t\t\t" +
              _vm._s(_vm.$translate("HoferAntikschmuck::Template.lernMore")) +
              "\n\t\t"
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }